module.exports = __webpack_public_path__ + "img/siji.bb0ad052.png";